import React, { Component, Fragment } from 'react';
import axios from 'axios';
import Navigation from '../../components/navigation.components';
import { withOktaAuth } from '@okta/okta-react';
import { Button, Modal, Tabs, Tab } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { MDBDataTable } from 'mdbreact';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'mdbreact/dist/css/mdb.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons'
import Chips from '../../components/chips.component';
import {MSG} from '../../constants'


class Notification extends Component {

	state = {
		page: {
			loaded: true
		},
		notifications: [],
		categories: [],
		formData: {
			forEmapta: true,
			client: "",
			category: "",
			name: "",
			recipients: "",
			accounts: [],
			categories: []
		},
		formErrors: [],
		formStatus: {
			submitted: false
		},
		modal: {
			notification: false,
			deleteNotification: false,
			defaultRecipient: false,
		},
		selected: null,
		defaultRecipient: {
			recipients: ""
		},
		recipientFormError: [],
	}

	componentDidMount() {
		this.getAllNotification();
		this.getDefaultRecipient();
		this.getAllCategories();
	}

	getAllCategories = async () => {
		let requests = await axios.get('/api/categories', {
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('access-token')
			}
		});

		let { status, data, error } = requests.data;
		if (status) {
			let { categories } = this.state;
			categories = data.filter(category => !category.emapta);
			this.setState({ categories });
		}
	}

	getAllNotification = async () => {
		let requests = await axios.get('/api/notifications', {
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('access-token')
			}
		});

		let { status, data, error } = requests.data;
		if (status) {
			let { notifications } = this.state;
			notifications = data;
			this.setState({ ...this.state, notifications });
		}
	}

	addNewNotificationModalHandler = e => {
		e.preventDefault();
		let { modal } = this.state;
		modal.notification = true;
		this.setState({ modal });
	}

	closeNotificationModalHandler = e => {
		e && e.hasOwnProperty('preventDefault') && e.preventDefault();
		let { modal, formData, formStatus, formErrors } = this.state;
		modal.notification = false;
		formData = {
			forEmapta: true,
			categories: [],
			client: "",
			name: "",
			recipients: "",
			accounts: []
		};
		formErrors = [];
		formStatus.submitted = false;
		this.setState({ ...this.state, modal, formData, formStatus, formErrors }, () => this.getAllNotification());
	}

	inputChangeHandler = e => {
		let { formData, formErrors } = this.state;

		if (['forEmapta'].includes(e.target.name)) {
			formData[e.target.name] = e.target.checked;
			formData.accounts = [];
			formData.categories = [];
		} else {
			formData[e.target.name] = e.target.value;
		}

		if (formErrors.includes(e.target.name)) {
			let idx = formErrors.indexOf(e.target.name);
			formErrors.splice(idx, 1);
		}

		this.setState({ ...this.state, formData, formErrors });
	}

	addAccountEventHandler = e => {
		let { formData, formErrors } = { ...this.state };

		if (formData.client === "") {
			formErrors.push('client');
		} else {
			formData.accounts.push(formData.client);
			formData.client = "";
		}

		this.setState({ ...this.state, formData });
	}

	removeAccountHandler = idx => {
		let { formData } = { ...this.state };
		formData.accounts.splice(idx, 1);
		this.setState({ ...this.state, formData });
	}

	addCategoryEventHandler = e => {
		let { formData, formErrors } = { ...this.state };

		if (formData.category === "") {
			formErrors.push('category');
		} else {
			formData.categories.push(formData.category);
			formData.category = "";
		}

		this.setState({ ...this.state, formData });
	}

	removeCategoryHandler = idx => {
		let { formData } = { ...this.state };
		formData.categories.splice(idx, 1);
		this.setState({ ...this.state, formData });
	}

	submitNotificationHandler = e => {
		let { formStatus, formErrors, formData } = { ...this.state };

		formErrors = [];
		Object.keys(formData).map(key => {
			if (!['client', 'accounts', 'id', 'category'].includes(key)) {
				if (formData[key] === "") {
					if (!formErrors.includes(key)) formErrors.push(key);
				}
			}

			if (formData.forEmapta) {
				if (["accounts"].includes(key)) {
					if (formData.accounts.length < 1) {
						if (!formErrors.includes("client")) formErrors.push("client");
					}
				}

				if (formErrors.includes("categories")) {
					let idx = formErrors.indexOf("categories");
					formErrors.splice(idx, 1);
				};
			} else {
				if (["categories"].includes(key)) {
					if (formData.categories.length < 1) {
						if (!formErrors.includes("category")) formErrors.push("category");
					}
				}

				if (formErrors.includes("accounts")) {
					let idx = formErrors.indexOf("accounts");
					formErrors.splice(idx, 1);
				};
			}
		})

		// console.log(207, formErrors);


		if (formErrors.length > 0) {
			this.setState({ ...this.state, formErrors });
		} else {
			formStatus.submitted = true;
			this.setState({ ...this.state, formStatus }, () => this.sendNotificationRequest());
		}
	}

	sendNotificationRequest = () => {
		let { formStatus, formData, modal } = { ...this.state };

		let data = {
			forEmapta: formData.forEmapta,
			name: formData.name,
			accounts: formData.accounts.map(r => r.toLowerCase()),
			categories: formData.categories,
			recipients: formData.recipients
		};

		if (formData.hasOwnProperty('id')) {
			data.id = formData.id;
		}

		axios.post('/api/notifications', data,
			{
				headers: {
					Authorization: 'Bearer ' + localStorage.getItem('access-token')
				}
			}).then(response => {
				formData = {
					client: "",
					accounts: [],
					recipients: "",
					name: "",
					forEmapta: true,
					categories: []
				}
				modal.notification = false;
				formStatus.submitted = false;
				this.setState({ ...this.state, formStatus, formData, modal }, () => this.getAllNotification());

				toast.success('Successfully created notification', {
					position: "bottom-left",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					progress: undefined,
				});

			}).catch(err => {

				toast.error("[Error code: sendNotificationRequest] "+MSG.error, {
					position: "bottom-left",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					progress: undefined,
				});

				formStatus.submitted = false;
				this.setState({ ...this.state, formStatus });
			})
	}

	updateNotificationModalHandler = (e, notif) => {
		e.preventDefault();
		let { modal, formData } = { ...this.state };

		// console.log(notif);
		formData = {
			client: "",
			id: notif._id,
			name: notif.name,
			recipients: notif.recipients,
			accounts: notif.clients,
			forEmapta: notif.forEmapta,
			categories: notif.categories
		};

		modal.notification = true;
		this.setState({ ...this.state, formData, modal });
	}

	closeDeleteCategory = e => {
		let { modal, selected } = this.state;
		modal.deleteNotification = false;
		selected = null;
		this.setState({ ...this.state, selected, modal });
	}

	deleteNotificationModalHandler = (e, notif) => {
		let { modal, selected } = this.state;
		modal.deleteNotification = true;
		selected = notif;
		this.setState({ ...this.state, modal, selected });
	}

	submitDeleteRequest = e => {
		e.preventDefault();
		let formStatus = this.state.formStatus;
		formStatus.submitted = true;
		this.setState({ ...this.state, formStatus }, () => {
			this.deleteNotificationRequest()
		});
	}

	deleteNotificationRequest = () => {
		let { modal, selected, formStatus } = this.state;
		// console.log(selected);
		axios.delete(`/api/notifications/${selected._id}`, {
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('access-token')
			}
		}).then(response => {
			modal.deleteNotification = false;
			selected = null;
			formStatus.submitted = false;
			this.setState({ ...this.state, modal, selected, formStatus }, () => this.getAllNotification());

			toast.success('Successfully deleted notification', {
				position: "bottom-left",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
			});

		}).catch(err => {
			formStatus.submitted = false;
			this.setState({ ...this.state, formStatus });
			toast.error('[Error code: deleteNotificationRequest] Something went wrong. Please contact administrator!', {
				position: "bottom-left",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
			});
		})
	}

	// Default Recipients
	setDefaultRecipientModalHandler = e => {
		let { modal } = { ...this.state };
		modal.defaultRecipient = true;
		this.setState({ ...this.state, modal });

	}

	closeDefaultRecipientModalHandler = e => {
		let { modal, recipientFormError } = { ...this.state };
		recipientFormError = [];
		modal.defaultRecipient = false;
		this.setState({ ...this.state, modal, recipientFormError });
	}

	defaultRecipientChangeHandler = e => {
		let { defaultRecipient, recipientFormError } = { ...this.state };
		defaultRecipient.recipients = e.target.value;
		if (recipientFormError.includes('recipients')) {
			let idx = recipientFormError.indexOf('recipients');
			recipientFormError.splice(idx, 1);
		}
		this.setState({ ...this.state, defaultRecipient, recipientFormError });
	}

	submitDefaultRecipientHandler = e => {
		let { defaultRecipient, recipientFormError, formStatus } = { ...this.state };

		recipientFormError = [];
		if (defaultRecipient.recipients === "") {
			if (!recipientFormError.includes('recipients')) {
				recipientFormError.push('recipients');
			}
		}

		if (recipientFormError.length > 0) {
			this.setState({ ...this.state, recipientFormError });
		} else {
			formStatus.submitted = true;
			this.setState({ ...this.state, formStatus }, () => this.submitDefaultRecipient());
		}
	}

	submitDefaultRecipient = () => {
		let { defaultRecipient, modal, formStatus } = { ...this.state };

		let data = {
			id: defaultRecipient.id,
			recipients: defaultRecipient.recipients
		}

		axios.post('/api/notifications/default/recipient', data,
			{
				headers: {
					Authorization: 'Bearer ' + localStorage.getItem('access-token')
				}
			}).then(response => {
				// console.log(340, response.data);

				modal.defaultRecipient = false;
				formStatus.submitted = false;
				this.setState({ ...this.state, formStatus, modal }, () => this.getDefaultRecipient());

				toast.success('Successfully updated default recipients', {
					position: "bottom-left",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					progress: undefined,
				});

			}).catch(err => {
				toast.error("[Error code: submitDefaultRecipient] Something went wrong. Please contact administrator.", {
					position: "bottom-left",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					progress: undefined,
				});

				formStatus.submitted = false;
				this.setState({ ...this.state, formStatus });
			})

	}

	getDefaultRecipient = e => {
		axios.get('/api/notifications/default/recipient', {
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('access-token')
			}
		}).then(response => {
			let { data } = response.data;
			if (data) {
				let { defaultRecipient } = { ...this.state };
				defaultRecipient.id = data._id;
				defaultRecipient.recipients = data.recipients;

				this.setState({ ...this.state, defaultRecipient });
			}
		});
	}

	render() {
		let { page, formData, formStatus, formErrors, modal, notifications, defaultRecipient, recipientFormError, categories } = this.state;

		let forExistingEmapta = {
			columns: [
				{ label: 'Name', field: 'name', sort: 'desc' },
				{ label: 'Recipients', field: 'recipients' },
				{ label: 'Accounts', field: 'clients' },
				{ label: 'Actions', field: 'actions', },
			],
			rows: []
		}


		let forNonEmapta = {
			columns: [
				{ label: 'Name', field: 'name', sort: 'desc' },
				{ label: 'Recipients', field: 'recipients', },
				{ label: 'Categories', field: 'categories' },
				{ label: 'Actions', field: 'actions' },
			],
			rows: []
		}


		if (notifications.length > 0) {
			notifications.map(notif => {

				if (notif.forEmapta) {
					let joinClients = "";
					if (Array.isArray(notif.clients) && notif.clients.length > 0) {
						joinClients = notif.clients.join(", ");
					}
					forExistingEmapta.rows.push({
						actions: <div style={{ display: 'block', width: "150px", textAlign: "center" }}>
							<button className='btn btn-sm btn-danger' style={{ margin: 0 }} onClick={e => this.deleteNotificationModalHandler(e, notif)} ><FontAwesomeIcon icon={faTrash} /></button> {" "}
							<button className='btn btn-sm btn-primary' style={{ margin: 0 }} onClick={e => this.updateNotificationModalHandler(e, notif)} ><FontAwesomeIcon icon={faPen} /></button>
						</div>,
						clients: joinClients,
						recipients: notif.recipients,
						name: notif.name
					});
				} else {
					let joinCategories = "";
					if (Array.isArray(notif.categories) && notif.categories.length > 0) {
						joinCategories = notif.categories.join(", ");
					}

					forNonEmapta.rows.push({
						actions: <>
							<button className='btn btn-sm btn-danger' style={{ margin: 0 }} onClick={e => this.deleteNotificationModalHandler(e, notif)} ><FontAwesomeIcon icon={faTrash} /></button> {" "}
							<button className='btn btn-sm btn-primary' style={{ margin: 0 }} onClick={e => this.updateNotificationModalHandler(e, notif)} ><FontAwesomeIcon icon={faPen} /></button>
						</>,
						categories: joinCategories,
						recipients: notif.recipients,
						name: notif.name
					});
				}
			})
		}

		return <>
			<Navigation />
			<ToastContainer
				position="bottom-left"
				autoClose={5000}
				hideProgressBar={true}
				newestOnTop={true}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable={false}
				pauseOnHover
			/>

			{page.loaded ?
				<div className='container'>

					<div className='row mt-3'>
						<div className='col-12' style={{ textAlign: 'right' }}>
							<button className='btn btn-primary' onClick={e => this.setDefaultRecipientModalHandler(e)}>Set default recipient</button>
						</div>
						<div className='col-12' style={{ textAlign: 'right' }}>
							<button className='btn btn-primary' onClick={e => this.addNewNotificationModalHandler(e)}>Add New Notification</button>
						</div>
					</div>
					<Tabs>
						<Tab eventKey="existingEmapta" title="Existing Emapta Employee">
							<div className="row mt-3">
								<div className="col-12">
									<MDBDataTable
										responsive
										striped
										bordered
										hover
										noBottomColumns
										data={forExistingEmapta}
										entriesOptions={[10, 20, 25]}
									// order={['submitted_at', 'desc']}
									/>
								</div>
							</div>
						</Tab>
						<Tab eventKey="nonEmapta" title="Non Emapta Employees">
							<div className="row mt-3">
								<div className="col-12">
									<MDBDataTable
										responsive
										striped
										bordered
										hover
										noBottomColumns
										data={forNonEmapta}
										entriesOptions={[10, 20, 25]}
									// order={['submitted_at', 'desc']}
									/>
								</div>
							</div>
						</Tab>
					</Tabs>
				</div>
				: <>Loading...</>
			}

			<Modal
				show={modal.notification}
				size="lg"
				onHide={e => this.closeNotificationModalHandler(e)}
				backdrop="static"
				keyboard={false}
			>
				<Modal.Header closeButton={!formStatus.submitted}>
					<Modal.Title>{formData.hasOwnProperty('id') ? "Update" : "Create"} Notification</Modal.Title>
				</Modal.Header>
				<Modal.Body>

					<form>
						<div className='row'>
							<div className='col-12'>
								<div className="form-check">
									<input
										className="form-check-input"
										type="checkbox"
										name="forEmapta"
										id="existingEmapta"
										checked={formData.forEmapta}
										onChange={e => this.inputChangeHandler(e)}
										disabled={formStatus.submitted}
									/>
									<label className="form-check-label" htmlFor="existingEmapta">
										For Existing Emapta Employee
									</label>
								</div>
							</div>
						</div>

						<div className='row mt-3'>
							<div className='col-12'>
								<label htmlFor="name">Notification Name *</label>
								<input
									type="text"
									name='name'
									id='name'
									value={formData.name}
									placeholder=""
									className={`form-control ${formErrors.includes('name') ? 'is-invalid' : ''}`}
									onChange={e => this.inputChangeHandler(e)}
									disabled={formStatus.submitted}
								/>
							</div>
						</div>

						<div className='row'>
							<div className='col-12 mt-3'>
								<label htmlFor='recipients'>Recipients *</label>
								<textarea
									name="recipients"
									id="recipients"
									style={{ width: "100%", resize: 'none' }}
									value={formData.recipients}
									onChange={e => this.inputChangeHandler(e)}
									className={`form-control ${formErrors.includes('recipients') ? 'is-invalid' : ''}`}
									rows={2}
									disabled={formStatus.submitted}
								/>
								<small className="text-muted form-text">Emails separated by comma.</small>
							</div>
						</div>

						{formData.forEmapta ?
							<div className='row'>
								<div className='col-10 mt-3'>
									<label htmlFor="client">Add Accounts/Clients *</label>
									<input
										type="text"
										name='client'
										id='client'
										value={formData.client}
										placeholder=""
										className={`form-control ${formErrors.includes('client') ? 'is-invalid' : ''}`}
										onChange={e => this.inputChangeHandler(e)}
										disabled={formStatus.submitted}
									/>
								</div>
								<div className='col-1'>
									<button
										type="button"
										className="btn btn-default btn-md"
										style={{ marginTop: 40 }}
										onClick={e => this.addAccountEventHandler(e)}
										disabled={formStatus.submitted}
									>
										<b className="bi bi-plus"></b>
									</button>
								</div>
							</div>
							:
							<div className='row'>
								<div className='col-10 mt-3'>
									<label htmlFor="categories">Add Categories *</label>
									<select
										className={`form-select ${formErrors.includes('category') ? 'is-invalid' : ''}`}
										name="category"
										disabled={formStatus.submitted}
										onChange={e => this.inputChangeHandler(e)}
										value={formData.category}
									>
										<option value="">Select Categories</option>
										{categories.filter(category => !formData.categories.includes(category.name)).map(category => <option key={category._id} value={category.name}>{category.name}</option>)}
									</select>
									{/* <input
										type="text"
										name='client'
										id='client'
										value={formData.client}
										placeholder=""
										className={`form-control ${formErrors.includes('client') ? 'is-invalid' : ''}`}
										onChange={e => this.inputChangeHandler(e)}
										disabled={formStatus.submitted}
									/> */}
								</div>
								<div className='col-1'>
									<button
										type="button"
										className="btn btn-default btn-md"
										style={{ marginTop: 40 }}
										onClick={e => this.addCategoryEventHandler(e)}
										disabled={formStatus.submitted}
									>
										<b className="bi bi-plus"></b>
									</button>
								</div>
							</div>

						}

						<div className='row mt-3'>
							<div className='col-12'>
								{formData.accounts.map((account, idx) =>
									<Chips key={idx} name={account} idx={idx} disabled={formStatus.submitted} removeChipHandler={idx => this.removeAccountHandler(idx)} />
								)}

								{formData.categories.map((category, idx) =>
									<Chips key={idx} name={category} idx={idx} disabled={formStatus.submitted} removeChipHandler={idx => this.removeCategoryHandler(idx)} />
								)}

							</div>
						</div>

					</form>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={e => this.closeNotificationModalHandler(e)} disabled={formStatus.submitted}>
						Close
					</Button>
					<Button variant="primary" onClick={e => this.submitNotificationHandler(e)} disabled={formStatus.submitted}>
						Submit
					</Button>
				</Modal.Footer>
			</Modal>


			{/* Delete Modal */}
			<Modal
				show={modal.deleteNotification}
				size="lg"
				onHide={e => this.closeDeleteCategory(e)}
				backdrop="static"
				keyboard={false}
			>
				<Modal.Header closeButton={!formStatus.submitted}>
					<Modal.Title>Delete Notification</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className='row'>
						<div className='col-12'>
							<p>
								Are you sure you want to delete {this.state.selected?.name}
							</p>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={this.closeDeleteCategory} disabled={formStatus.submitted}>
						Close
					</Button>
					<Button variant="primary" onClick={this.submitDeleteRequest} disabled={formStatus.submitted}>
						Submit
					</Button>
				</Modal.Footer>
			</Modal>

			<Modal
				show={modal.defaultRecipient}
				size="lg"
				onHide={e => this.closeDefaultRecipientModalHandler(e)}
				backdrop="static"
				keyboard={false}
			>
				<Modal.Header closeButton={!formStatus.submitted}>
					<Modal.Title>Set Default Recipients</Modal.Title>
				</Modal.Header>
				<Modal.Body>

					<form>

						<div className='row'>
							<div className='col-12 mt-3'>
								<label htmlFor='recipients'>Recipients *</label>
								<textarea
									name="recipients"
									id="recipients"
									style={{ width: "100%", resize: 'none' }}
									value={defaultRecipient.recipients}
									onChange={e => this.defaultRecipientChangeHandler(e)}
									className={`form-control ${recipientFormError.includes('recipients') ? 'is-invalid' : ''}`}
									rows={2}
									disabled={formStatus.submitted}
								/>
								<small className="text-muted form-text">Emails separated by comma.</small>
							</div>
						</div>

					</form>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={e => this.closeDefaultRecipientModalHandler(e)} disabled={formStatus.submitted}>
						Close
					</Button>
					<Button variant="primary" onClick={e => this.submitDefaultRecipientHandler(e)} disabled={formStatus.submitted}>
						Submit
					</Button>
				</Modal.Footer>
			</Modal>
		</>

	}
}


export default withOktaAuth(Notification);

